import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ea9b63e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9b63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea9b63e')) {
      api.createRecord('5ea9b63e', component.options)
    } else {
      api.reload('5ea9b63e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ea9b63e&scoped=true", function () {
      api.rerender('5ea9b63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TableContent/index.vue"
export default component.exports